import React from "react";
import { getGraphNode } from "../selectors";
import Helmet from "react-helmet";

import ReactMarkdown from "react-markdown";
import NavBar from "../components/NavBar";
import { H3 } from "../components/typography";

import Section from "../components/blocks/Section";
import Pad from "../components/blocks/Pad";
import Spacer from "../components/blocks/Spacer";
import Background from "../components/blocks/Background";
import { PostBody } from "../components/Post";
import favicon from "../../assets/logofavcon@2x.png";

const CoiBody = PostBody.extend`
  h2 {
    margin-left: -1.5rem;
    font-size: 1.5rem;
    padding-top: .5rem;
    padding-bottom: 1.5rem;
  }
`;

export default ({ data }) => {
  const content = getGraphNode(data, "Legal");
  return (
    <div>
      <Helmet
        title="Contraline COI Policy"
        meta={[{ name: "Contraline", content: "COI Policy" }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <NavBar color="dark" background="white" />
      <Background color="white" fixed={true}>
        <Section noBorder fixed={true} vPad={false}>
          <Spacer span={2} />
          <Pad h={2}>
            <Pad h={5} v={1}>
              <H3>COI Policy</H3>
            </Pad>
            <CoiBody>
              <ReactMarkdown source={content.coiPolicy.coiPolicy} />
            </CoiBody>
          </Pad>
          <Spacer span={2} />
        </Section>
      </Background>
    </div>
  );
};

export const pageQuery = graphql`
  query CoiPolicyQuery {
    allContentfulLegal {
      edges {
        node {
          id
          coiPolicy {
            coiPolicy
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/coi-policy.js